import styles from './Modal.module.scss';
import { useModalContext } from './ModalContext';
import clsx from 'clsx';
import React, { useEffect } from 'react';

const ModalSection = ({ children, suppressed }) => {
  const {
    removeHasModalSection,
    modalPaddings,
    setHasModalSection,
    isMobileFullPage,
  } = useModalContext();

  const classes = clsx(styles.modalSection, styles[suppressed], {
    [` ${styles.mobile}`]: isMobileFullPage,
  });
  /*
      Run on every re-render to prevent setting hasModalSection to false when there's more sections
     */
  useEffect(() => {
    if (setHasModalSection) setHasModalSection();
  });

  useEffect(
    () => () => {
      if (removeHasModalSection) removeHasModalSection();
    },
    [removeHasModalSection],
  );

  return (
    <section
      className={classes}
      suppressed={suppressed}
      style={{
        '--modal-paddings': modalPaddings && `${modalPaddings}px`,
      }}
    >
      {children}
    </section>
  );
};

export default ModalSection;
